import { Link } from 'react-router-dom'

/**
 * The design's list row (profile and settings): 54–56px, the label on the
 * start side, a quiet value on the end side. A row is a link when it has
 * somewhere to go, a button when it opens something here, and plain text
 * otherwise — a row that looks tappable and does nothing is a promise the
 * app cannot keep, so an inert row draws no chevron and no hover.
 */
export default function ListRow({ label, value, to, onClick, destructive = false, quiet = false }) {
  const tone = destructive ? 'text-bad' : quiet ? 'text-ink-3' : 'text-ink'
  const body = (
    <>
      <span className={`flex-1 text-start text-sm font-medium ${tone}`}>{label}</span>
      {value ? <span className="shrink-0 text-xs text-ink-3">{value}</span> : null}
    </>
  )
  const frame = 'flex h-14 w-full items-center gap-[11px] card-soft rounded-tile px-4'

  if (to) {
    return (
      <Link to={to} className={`${frame} transition hover:bg-surface-2`}>
        {body}
      </Link>
    )
  }
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={`${frame} transition hover:bg-surface-2`}>
        {body}
      </button>
    )
  }
  return <div className={frame}>{body}</div>
}
